import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { AppConstants } from '../app-constants.service';


@Component({
    selector: 'pagination',
    templateUrl: './pager.component.html',
    styleUrls: ['./pager.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Pager implements OnChanges {

    @Input()
    numItems = -1;

    @Input()
    current = 0;

    @Output()
    goToPageEvent: EventEmitter<number> = new EventEmitter();

    numPages: number;

    itemsPerPage: number;

    numbers: number[] = [];

    constructor(private readonly appConfiguration: AppConstants) {
        this.itemsPerPage = appConfiguration.pagerDefaultNumPerPage;
    }

    ngOnChanges(): void {
        this.numbers = [];
        this.numPages = Math.ceil(this.numItems / this.itemsPerPage);

        for(let i = 0; i < this.numPages; i++) {
            this.numbers.push(i);
        }
    }

    click(index: number): void {
        this.goToPageEvent.emit(index);
    }

}
